import React from 'react';
import { useTheme } from '@mui/material/styles';
import { TextField, TextFieldProps } from '../TextField';
export interface TitleFieldProps
  extends Exclude<TextFieldProps, 'variant' | 'hiddenLabel' | 'size' | 'sx' | 'InputProps' | 'inputProps'> {
  readOnly?: boolean;
  inputTestId?: string;
  size?: 'small' | 'medium';
}
/**
 * Renders a white FilledInput component matching the title field designs
 */
export const TitleField: React.FC<React.PropsWithChildren<TitleFieldProps>> = ({
  readOnly = false,
  inputTestId = 'title-field',
  size = 'medium',
  ...rest
}: TitleFieldProps) => {
  const theme = useTheme();
  return (
    <TextField
      {...rest}
      className="title-field"
      slotProps={{
        input: {
          readOnly: readOnly,
        },
      }}
      sx={{
        '&.title-field': {
          '& .MuiInputBase-root': {
            border: '2px solid transparent',
            '&:focus-within': {
              boxShadow: 'none',
            },
            '&.Mui-error': {
              boxShadow: 'none',
            },
            '& .MuiInputBase-input': {
              padding: '0 4px',
              fontSize: size === 'small' ? '18px' : '24px',
              fontWeight: 700,
              height: size === 'small' ? '24px' : '32px',
            },
            '&.Mui-focused': {
              border: `2px solid ${theme.palette.primary.main}`,
              borderRadius: '8px',
            },
          },
        },
      }}
      inputProps={{ 'data-testid': inputTestId }}
    />
  );
};
